import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import {
  TextFilter,
  SafePipe,
  SafeHTML,
  FileSize,
  SafeStyles,
  Truncate,
  FriendlyType,
  TransformTextPipe,
  TranslationPipe,
  TranslationFromStringPipe,
  FormatText,
  HighlightPipe,
} from "@app/shared/pipe.module";
import { NebularModule } from "@app/shared/nebular.module";
import { EditorModule as TinyMCEModule } from "@scaffold/tinymce/editor/editor.module";
import { MentionModule } from "@app/commenting/mentions/mention.module";
import { ColorPickerModule } from "ngx-color-picker";
import { FileDropDirective } from "./file-drop.directive";
import { NgJsonEditorModule } from "ang-jsoneditor";
import { ShowFalsyPipe } from "./pipe.module";
@NgModule({
  imports: [CommonModule, MentionModule, FormsModule],
  exports: [
    HighlightPipe,
    ShowFalsyPipe,
    SafePipe,
    SafeHTML,
    TextFilter,
    SafeStyles,
    FileSize,
    FormatText,
    FriendlyType,
    Truncate,
    TinyMCEModule,
    MentionModule,
    NebularModule,
    ColorPickerModule,
    NgJsonEditorModule,
    TransformTextPipe,
    TranslationPipe,
    TranslationFromStringPipe,
  ],
  declarations: [
    HighlightPipe,
    ShowFalsyPipe,
    SafePipe,
    SafeHTML,
    TextFilter,
    FileSize,
    FormatText,
    FriendlyType,
    SafeStyles,
    Truncate,
    FileDropDirective,
    TransformTextPipe,
    TranslationPipe,
    TranslationFromStringPipe,
  ],
})
export class SharedModule {}
